import { useContext, useMemo } from 'react';

import { DownloadOutlined } from '@ant-design/icons';

import { ActionButton } from '@hdi-seguros/web-components.action-button';
import { SectionSummary } from '../../../../../../../../../shared/components';
import { GenericDataFormContext, QUOTATION_BUTTON, StepOneFormContext } from '../../../../../shared';

import {
  Column,
} from '../../../../../../../../production/InsurancePolicyDetail/utils/renderSections';
import {
  formattedPrice,
} from '../../../../../../../../../shared/utils';

import { StepFourFormContext } from '../../contexts/StepFourForm';
import { getQuoteDocumentPDF, transformToPdfQuote } from '../../../../../utils';
import { BranchDocumentsURL, BudgetType } from '../../../../../utils/quotation-documents.enum';
import { StepThreeFormContext } from '../../../StepThree/contexts/StepThreeForm';
import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';
import { QuotationContextData } from '../../../../../../../../../shared/interfaces/services/quote-pdf-service';

export const Summary = () => {
  const { stepOneForm, clientSelected } = useContext(StepOneFormContext);
  const { stepTwoForm,  rubricSelected} = useContext(StepTwoFormContext);
  const { stepThreeForm, activeKey, tabs, plansByActivityList } = useContext(StepThreeFormContext);
  const { quotationResponse, labelButton, firePaymentMethodsForm, fireQuotationComponents,
  } = useContext(StepFourFormContext);
  const { quotationForm } = useContext(WizardDataFormContext);
  const { provinceList, allLocalitiesPerProvince, ivaConditionList, paymentMethods, allCoveragesPerPlan, paymentMethodsList, } = useContext(GenericDataFormContext);

  const ctx: QuotationContextData = {
    quotationForm,
    clientSelected,
    stepOneForm,
    stepTwoForm, rubricSelected,
    stepThreeForm, activeKey, tabs, plansByActivityList,
    quotationResponse, firePaymentMethodsForm, paymentMethodsList, fireQuotationComponents,
    provinceList, allLocalitiesPerProvince, ivaConditionList, paymentMethods, allCoveragesPerPlan,
    branchDocumentsURL: BranchDocumentsURL.INCENDIO
  };

  const summaryInfo: Array<Column[]> = useMemo(
    () => [
      [
        {
          label: 'Total suma asegurada:',
          value:
            labelButton === QUOTATION_BUTTON.RECOTIZAR ? (
              labelButton
            ) : (
              <b>{`$ ${formattedPrice(quotationResponse?.sumaAsegurada)}`}</b>
            ),
          columnSize: {
            sm: { span: 12 },
            xs: { span: 12 },
            md: { span: 10 },
            lg: { span: 7 },
          },
        },
        {
          label: 'Prima técnica:',
          value:
            labelButton === QUOTATION_BUTTON.RECOTIZAR
              ? labelButton
              : `$ ${formattedPrice(quotationResponse?.prima)}`,
          columnSize: {
            sm: { span: 12 },
            xs: { span: 12 },
            md: { span: 7 },
            lg: { span: 7 },
          },
        },
        {
          label: 'Comisión:',
          value:
            labelButton === QUOTATION_BUTTON.RECOTIZAR
              ? labelButton
              : `$ ${formattedPrice(
                  quotationResponse?.condicionesComerciales.impComision
                )}`,
          columnSize: {
            sm: { span: 12 },
            xs: { span: 12 },
            md: { span: 6 },
            lg: { span: 7 },
          },
        },
        {
          label: 'Premio:',
          value:
            labelButton === QUOTATION_BUTTON.RECOTIZAR
              ? labelButton
              : `$ ${formattedPrice(quotationResponse?.premio)}`,
          columnSize: {
            sm: { span: 12 },
            xs: { span: 12 },
            md: { span: 10 },
            lg: { span: 7 },
          },
        },
        {
          label: 'Acciones',
          value:
            labelButton === QUOTATION_BUTTON.RECOTIZAR ? (
              labelButton
            ) : (
              <>
                <ActionButton
                  className='btn-accent-outline-barbuss'
                  type='secondary'
                  label='Productor'
                  onClick={() => getQuoteDocumentPDF(transformToPdfQuote(ctx, BudgetType.PRODUCTOR), BranchDocumentsURL.INCENDIO)}
                  icon={<DownloadOutlined />}
                />
                <ActionButton
                  className='btn-accent-outline-barbuss'
                  type='secondary'
                  style={{ marginLeft: '1rem' }}
                  color='secondaryDefault'
                  label='Cliente'
                  onClick={() => getQuoteDocumentPDF(transformToPdfQuote(ctx, BudgetType.CLIENTE), BranchDocumentsURL.INCENDIO)}
                  icon={<DownloadOutlined />}
                />
              </>
            ),
          columnSize: {
            sm: { span: 24 },
            xs: { span: 24 },
            md: { span: 14 },
            lg: { span: 10 },
          },
        },
      ],
    ],
    [labelButton, quotationResponse]
  );

  return <SectionSummary summaryInfo={summaryInfo} />
};
